import { render, staticRenderFns } from "./AdminEmailEntry.vue?vue&type=template&id=0a60a154&"
import script from "./AdminEmailEntry.vue?vue&type=script&lang=js&"
export * from "./AdminEmailEntry.vue?vue&type=script&lang=js&"
import style0 from "./AdminEmailEntry.vue?vue&type=style&index=0&id=0a60a154&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports